<template>
  <div class="template">

    <component :is="object" class="component"></component>
    <!--ObjectTemplate :object="object"></ObjectTemplate-->

  </div>
</template>

<script>

import DJLanding from '@/components/objects/drottningensjuvelsmycke/DJLanding'

export default {
  components: {
  },
  data () {
    return {
      objects: [
        DJLanding
      ]
    }
  },
  computed: {
    object: function () {
      return this.objects.filter(o => o.route == this.$route.params['objectRoute'])[0];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.component{
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/ObjectContainer.vue